import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import person from "../Asserts/personicon.png";

const slides = [
  {
    image: person,
    heading: "Founder One",
    text: "This is a dummy description for slide 1. Customize text goes here.",
  },
  {
    image: person,
    heading: "Founder Two",
    text: "This is a dummy description for slide 2. Customize text goes here.",
  },
  {
    image: person,
    heading: "Founder Three",
    text: "This is a dummy description for slide 3. Customize text goes here.",
  },
];

function Slider() {
  const [index, setIndex] = useState(0);

  const nextSlide = () => setIndex((index + 1) % slides.length);
  const prevSlide = () => setIndex((index - 1 + slides.length) % slides.length);

  useEffect(() => {
    const interval = setInterval(nextSlide, 5000); // Auto-slide every 5 seconds
    return () => clearInterval(interval);
  }, [index]);

  return (
    <div className="relative w-full max-w-4xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden mt-6 mb-10">
      {/* Slide Content */}
      <div className="flex flex-col md:flex-row items-center justify-between gap-6 p-6">
        {/* Image Section */}
        <div className="w-full md:w-1/2 flex justify-center">
          <AnimatePresence mode="wait">
            <motion.img
              key={index}
              src={slides[index].image}
              alt={slides[index].heading}
              className="w-full max-w-[300px] md:max-w-[400px] h-auto rounded-lg shadow-md"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.5 }}
            />
          </AnimatePresence>
        </div>

        {/* Text Section */}
        <div className="w-full md:w-1/2 text-center md:text-left space-y-4">
          <h2 className="text-xl md:text-2xl font-bold text-[#FF6F00]">
            {slides[index].heading}
          </h2>
          <p className="text-sm md:text-base text-gray-700 leading-relaxed">
            {slides[index].text}
          </p>
          <div className="flex justify-center md:justify-start gap-4">
            <button
              onClick={prevSlide}
              className="bg-[#FF6F00] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#E65C00] transition duration-300"
            >
              Previous
            </button>
            <button
              onClick={nextSlide}
              className="bg-[#FF6F00] text-white px-4 py-2 rounded-lg shadow-md hover:bg-[#E65C00] transition duration-300"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Slider;
